import { Injectable } from '@angular/core';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { Question } from '@app/forms/subscription/definition/interface';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { ValidationBridgeService } from './validation-bridge.service';

@Injectable({
  providedIn: 'root',
})
export class RiskProfileQuestionsService {
  private organization: any;

  constructor(
    private cBService: ValidationBridgeService,
    private attributionDao: AttributionDao,
  ) {
    this.attributionDao.getOrganization().subscribe(organization => {
      this.organization = organization;
    });
  }
  riskProfileQustions: Question[] = [
    {
      name: 'profilePage',

      alwaysSkip: true,
      template: 'profilePage',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      callbackValidation: entity => {
        return true;
      },
      title: 'Déterminez votre profil.',
      category: 'Profil patrimonial',
      categoryId: 1,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    // {
    //   id: 11,
    //   name: "income",
    //   step: "11",

    //   template: "income",
    //   callbackValidation: (entity) => {
    //     return this.cBService.getIncome(entity);
    //   },

    //   title: "Quels sont les revenus annuels nets de votre foyer fiscal ?",
    //   type: "owners",
    //   physicalUserOnly: true,
    //   callbackBasedOn(pledge: PledgeRead) {
    //     return !pledge?.owners?.[0]?.physicalUser;
    //   },
    //   category: "Profil patrimonial",
    //   categoryId: 4,
    //   productType: [
    //     "ASSURANCE_VIE",
    //     "PER",
    //     "SCPI",
    //     "GIRARDIN",
    //     "CROWDFUNDING",
    //     "FCPI","FCPR","FPS",
    //     "PRIVATE_EQUITY",
    //     "FIP",
    //     "LMNP",
    //     "UNFURNISHED",
    //     "CAT",
    //   ],
    // },
    {
      name: 'assessmentAssetsIncome',

      template: 'assessmentAssetsIncome',
      title: 'Répartition du revenu net annuel',
      callbackValidation: entity => {
        return this.cBService.getAssessmentAssetsIncome(entity);
      },
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'Profil patrimonial',
      categoryId: 5,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    // {
    //   name: "assessmentAssetsIncomeServiceDelivery",

    //   template: "assessmentAssetsIncomeServiceDelivery",
    //   title: "Répartition du revenu net annuel",
    //   callbackValidation: (entity) => {
    //     return this.cBService.getAssessmentAssetsIncomeServiceDelivery(entity);
    //   },
    //   physicalUserOnly: true,
    //   callbackBasedOn(pledge: PledgeRead) {
    //     return !pledge?.owners?.[0]?.physicalUser;
    //   },
    //   category: "Profil patrimonial",
    //   categoryId: 5,
    //   productType: ["PRESTATION"],
    // },
    {
      name: 'profession',

      template: 'profession',
      callbackValidation: entity => {
        return this.cBService.getProfession(entity, this.organization);
      },
      title: 'Quelle est votre profession ?',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'Profil patrimonial',
      categoryId: 6,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'heritage',

      template: 'heritage',
      callbackValidation: entity => {
        return this.cBService.getHeritage(entity);
      },
      title: 'A combien estimez-vous votre patrimoine ?',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'Profil patrimonial',
      categoryId: 7,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
      ],
    },
    {
      name: 'assessmentAssets',
      template: 'assessmentAssets',
      title: 'Répartition du patrimoine',
      callbackValidation: entity => {
        return this.cBService.getAssessmentAssets(entity);
      },
      callbackBasedOn(pledge: PledgeRead) {
        return false;
      },
      category: 'Profil patrimonial',
      categoryId: 8,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',
        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'assessmentAssetsOrigin',

      template: 'assessmentAssetsOrigin',
      title: "Répartition de l'origine du patrimoine",
      callbackValidation: entity => {
        return this.cBService.getAssessmentAssetsOrigin(entity);
      },
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'Profil patrimonial',
      categoryId: 9,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'loanRepartitionForm',

      template: 'loanRepartitionForm',
      title: 'Répartition des crédits',
      callbackValidation: entity => {
        return this.cBService.getLoanRepartitionForm(entity);
      },
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'Profil patrimonial',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'principalResidence',

      template: 'principalResidence',
      callbackValidation: entity => {
        return this.cBService.getPrincipalResidence(entity);
      },
      title: 'Concernant votre résidence principale',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'Profil patrimonial',
      categoryId: 10,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'savingsCapacity',

      template: 'savingsCapacity',
      callbackValidation: entity => {
        return this.cBService.getSavingsCapacity(entity);
      },
      title: "Quelles sont vos capacités d'épargne ?",
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners[0]?.physicalUser;
      },
      category: 'Profil patrimonial',
      categoryId: 11,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },

    {
      name: 'investmentObjectiveHeritage',
      template: 'investmentObjectiveHeritage',
      callbackValidation: (entity: PledgeRead) => {
        return entity?.accountInformations?.investmentGoals?.length > 0;
      },
      title: 'Quels sont vos objectifs patrimoniaux ?',
      subTitle: 'plusieurs choix sont possibles',
      type: 'owners',
      category: 'Profil patrimonial',

      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'investmentHorizon',
      template: 'investmentHorizon',
      callbackValidation: (entity: PledgeRead) => {
        return !!entity?.accountInformations?.investmentHorizon;
      },
      title: "Horizon d'investissement",
      type: 'owners',
      category: 'Profil patrimonial',
      productType: [],
    },
    {
      name: 'esgSituation',
      template: 'esgSituation',
      callbackValidation: (entity: PledgeRead) => {
        return entity?.owners?.[0]?.esgProfil?.includeESG !== undefined || null;
      },
      title: 'Inclure un critère ESG dans votre projet ?',
      type: 'owners',
      category: 'Profil patrimonial',

      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'taxonomy',
      template: 'taxonomy',
      callbackValidation: (pledge: PledgeRead) => {
        const { taxonomy, sustainability } =
          pledge?.owners?.[0]?.esgProfil || {};
        return taxonomy != null && sustainability != null;
      },
      callbackBasedOn: (pledge: PledgeRead) => {
        return !pledge?.owners.some(o => o?.esgProfil?.includeESG);
      },
      title: 'Profil ESG - Répartition des investissements',
      type: 'owners',
      category: 'Profil patrimonial',

      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'esgInvestmentList',
      template: 'esgInvestmentList',
      callbackValidation: (pledge: PledgeRead) => {
        return true;
      },
      callbackBasedOn: (pledge: PledgeRead) => {
        return !pledge?.owners.some(o => o?.esgProfil?.includeESG);
      },
      title: 'Profil ESG - Investissements privilégiés',
      type: 'owners',
      category: 'Profil patrimonial',

      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'esgInvestmentSituation',
      template: 'esgInvestmentSituation',
      callbackValidation: (pledge: PledgeRead) => {
        return true;
      },
      callbackBasedOn: (pledge: PledgeRead) => {
        return !pledge?.owners.some(o => o?.esgProfil?.includeESG);
      },
      title: 'Profil ESG - Investissements à écarter',
      type: 'owners',
      category: 'Profil patrimonial',

      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'smokerForm',
      template: 'smokerForm',
      callbackValidation: (entity: PledgeRead) => {
        return this.cBService.getSmoker(entity);
      },
      title: 'Profil emprunteur - Fumeur',
      type: 'owners',
      category: 'Profil patrimonial',
      productType: ['BORROWER_INSURANCE'],
    },
    {
      name: 'deplacementTravailHauteurForm',
      template: 'deplacementTravailHauteurForm',
      callbackValidation: (entity: PledgeRead) => {
        return this.cBService.getDeplacementTravailHauteur(entity);
      },
      title:
        'Profil emprunteur - Déplacement kilométrique et travail en hauteur',
      type: 'owners',
      category: 'Profil patrimonial',
      productType: ['BORROWER_INSURANCE'],
    },
    {
      name: 'travailManuelForm',
      template: 'travailManuelForm',
      callbackValidation: (entity: PledgeRead) => {
        return this.cBService.getTravailManuel(entity);
      },
      title: 'Profil emprunteur - Travail manuel',
      type: 'owners',
      category: 'Profil patrimonial',
      productType: ['BORROWER_INSURANCE'],
    },
    {
      name: 'travailRisqueForm',
      template: 'travailRisqueForm',
      callbackValidation: (entity: PledgeRead) => {
        return this.cBService.getTravailRisque(entity);
      },
      title: 'Profil emprunteur - Travail risque',
      type: 'owners',
      category: 'Profil patrimonial',
      productType: ['BORROWER_INSURANCE'],
    },
    {
      name: 'sportDeplacementsForm',
      template: 'sportDeplacementsForm',
      callbackValidation: (entity: PledgeRead) => {
        return this.cBService.getSportDeplacements(entity);
      },
      title: 'Profil emprunteur - Sport et déplacements étrangers',
      type: 'owners',
      category: 'Profil patrimonial',
      productType: ['BORROWER_INSURANCE'],
    },
    {
      name: 'optionsEmprunteurForm',
      template: 'optionsEmprunteurForm',
      callbackValidation: (entity: PledgeRead) => {
        return this.cBService.getOptionsEmprunteur(entity);
      },
      title: 'Profil emprunteur - Options',
      type: 'owners',
      category: 'Profil patrimonial',
      productType: ['BORROWER_INSURANCE'],
    },
  ];
}
